// Config por entorno vía Vue CLI (.env.development / .env.production).
// VUE_APP_SOCKET_TOKEN lo inyecta CI (secret) o .env.development.local — NUNCA commitear el token.
module.exports = {
  DEBUG: process.env.VUE_APP_DEBUG === "true",
  DEV: process.env.VUE_APP_DEBUG === "true",
  API_SOCKET: process.env.VUE_APP_SOCKET_TOKEN || ""
};
